/**
 * Convert a string to snake case, 'foo_bar'
 * @function string.snakeCase
 * @param {String} str
 * @returns {String}
 */
export { default } from 'lodash/snakeCase';
